const tabs = () => {
  const blocks = document.querySelectorAll(".main-tabs");

  blocks.forEach((block) => {
    const buttons = block.querySelectorAll(".tab-btn");
    const contents = block.querySelectorAll(".main-tab-content");

    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const tabId = btn.getAttribute("data-tab");
        const images = block.querySelectorAll(".tab-image");
        buttons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        contents.forEach((content) => {
          content.classList.remove("active");
          if (content.getAttribute("data-content") === tabId) {
            content.classList.add("active");
          }
        });
        images.forEach((img) => {
          img.classList.remove("active");
          if (img.getAttribute("data-content") === tabId) {
            img.classList.add("active");
          }
        });
      });
    });
  });
};
document.addEventListener("DOMContentLoaded", function () {
  tabs();
});
